import { useEffect } from 'react';

import { Layout } from '../../components'
import { DRAWER_KEYS } from '../../store/constants'
import { CustomersPanel } from '../../components/panels';


const CustomersPage = () => {

    useEffect(() => {
        document.title = 'Clientes | LCD'
    }, [])

    return (
        <Layout selectedKey={DRAWER_KEYS.CUSTOMERS}>
            <CustomersPanel />
        </Layout>
    )
}

export default CustomersPage
